import React from "react";
import { Select } from "antd";
import _ from "lodash";
import { ApplicationModel } from "../../../../../../../viewModels/Applications/ApplicationModel";
import { FtlApplicationUserOptions } from "../../../../../../../dto/Applications/ApplicationDto";

type Props = {
  application: ApplicationModel;
  onChange?: (application: ApplicationModel) => void;
  onCommit?: () => void;
  canEdit: boolean;
  options: Array<{ value: string; label: React.ReactNode }>;
};

const FtlSelectedOptionsCell = React.memo(({ application, canEdit, onChange, options, onCommit }: Props) => {
  const value = options.find((x) => application.selectedOptions.includes(x.value as FtlApplicationUserOptions))?.value;
  return canEdit && onChange ? (
    <Select
      variant="borderless"
      value={value}
      options={options}
      suffixIcon={null}
      onChange={(v) => {
        const copy = _.clone(application.selectedOptions);
        _.remove(copy, (x) => x === value);
        copy.push(v as FtlApplicationUserOptions);
        onChange({
          ...application,
          selectedOptions: copy,
        });
        onCommit?.();
      }}
      style={{ width: "100%" }}
    />
  ) : (
    <>{options.find((x) => application.selectedOptions.includes(x.value as FtlApplicationUserOptions))?.label}</>
  );
});

export default FtlSelectedOptionsCell;
